import _ from 'underscore';

export const ObjectHelper = {
  isEqual(obj1: any, obj2: any): boolean {
    return _.isEqual(obj1, obj2);
  },
};